import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { Settings, User } from "react-feather";
import { Link } from "react-router-dom";
import tool from "./img/tool.png";
import user from "./img/user2.jpeg";

const DollarInr = () => {
  const [selectedCurrency, setSelectedCurrency] = useState("INR");

 useEffect(() => {
  const storedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  setSelectedCurrency(storedCurrency);
  sessionStorage.setItem("selectedCurrency", storedCurrency);

  // Always fetch and update the dollar rate
  axios.get(`${baseurl}getDollarRate`)
    .then((res) => {
      if (res.data.success && res.data.rate) {
        localStorage.setItem("dollarRate", res.data.rate);
        console.log("Dollar Rate Fetched & Updated:", res.data.rate);
      }
    })
    .catch((err) => {
      console.error("Error fetching dollar rate:", err);
    });
}, []);


  const handleChange = (currency) => {
    setSelectedCurrency(currency);
    sessionStorage.setItem("selectedCurrency", currency);
    console.log("Updated selectedCurrency:", currency);
    window.location.reload(); // Reload to apply changes globally
  };

  return (
    <>
      {/* Desktop select dropdown */}
      <div className="d-none d-md-block">
        <select
          value={selectedCurrency}
          onChange={(e) => handleChange(e.target.value)}
          className="currency-select"
          style={{ width: "150px" }}
        >
          <option value="INR">INR (₹)</option>
          <option value="USD">USD ($)</option>
        </select>
      </div>

     
{/* section toggel  */}
<div className="currency-toggle">
    <button className={`currency-btn ${selectedCurrency === "INR" ? "active" : "activeed"}`} onClick={() => handleChange("INR")}>INR</button>
    <button className={`currency-btn ${selectedCurrency === "USD" ? "active" : "activeed"}`}  onClick={() => handleChange("USD")}>USD</button>
</div>

<div className="tool-toggle">
    <Link to="/service-repair" className={`currency-btn activeed m-1`} ><img src={tool} className="img-fluid" style={{maxHeight: '40px'}} />
    <br/>Service</Link>
    <Link to="/education-training"  className={`currency-btn activeed m-1`} >
    <img src={user} className="img-fluid" style={{maxHeight: '40px', borderRadius: '6px'}} />
   <br/> Education
    </Link>
</div>

    </>
  );
};
 
export default DollarInr;
